import apiClient from '@/services/api-client';

/**
 * @template S, R
 * @typedef {import('vuex').ActionTree<S, R>} ActionTree<S, R>
 */
/**
 * @typedef {import('@/store/root.state').RootState} RootState
 * @typedef {import('./employees-single.state').EmployeesSingleState} EmployeesSingleState
 */

/** @type {ActionTree<EmployeesSingleState, RootState>} */
export const employeesSingleActions = {
  getEmployee: async ({ commit }, { employeeId }) => {
    const { data } = await apiClient.employeeApi.getEmployee(employeeId);

    commit('setEmployee', data);
  },
  getEmployeeOvertimeFlags: async ({ commit }, { employeeId }) => {
    const { data } = await apiClient.employeeApi.getEmployeeOvertimeFlagsHistory({ employeeId });

    commit('setEmployeeOvertimeFlags', data);
  },
  updateEmployee: (context, { employeeId, patch }) => apiClient.employeeApi.updateEmployee(employeeId, patch),
  updateEmployeeDivision: (context, { employeeId, divisionId }) => apiClient.employeeApi.updateEmployeeDivision(employeeId, { division_id: divisionId }),

  getSchedule: async ({ commit }, params) => {
    const { data: schedule } = await apiClient.employeeApi.getSchedule(params);

    commit('setSchedule', schedule);
  },
};
